module.exports = __webpack_public_path__ + "img/home-active.bbd860dc.svg";